const DAYS_IN_WEEK = 7;

export const calculateDaysUntilNextWeek = (surveyStartDateNumber: number = 1): number => {
  const today = new Date();
  const todayDayOfWeek = today.getDay() === 0 ? DAYS_IN_WEEK : today.getDay(); // 1-Mon ... 7-Sun
  let daysUntilSurvey = surveyStartDateNumber - todayDayOfWeek;
  if (daysUntilSurvey <= 0) {
    daysUntilSurvey += DAYS_IN_WEEK;
  }
  return daysUntilSurvey;
};
